import { unreachable } from "@/lib/util/control-flow";

import { HubTab } from "@/dashboard/types/hub";

export const HUB_TAB_QUERY_PARAM = "t";
export const HUB_CHANNEL_TYPE_QUERY_PARAM = "ct";

/**
 * Maps a HubTab to a user-facing label
 */
export function getHubTabLabel(tab: HubTab) {
  return tab === HubTab.ALL
    ? "All"
    : tab === HubTab.FLAGGED
      ? "Flagged"
      : tab === HubTab.TRANSFERRED
        ? "Transferred"
        : tab === HubTab.TRANSFERRED_INTERNAL
          ? "Netic CSRs"
          : tab === HubTab.RESOLVED
            ? "Handled by Netic"
            : unreachable(tab);
}

/**
 * Parses a HubTab from a string
 */
export function parseHubTab(raw: string | null | undefined): HubTab | undefined {
  return raw === HubTab.FLAGGED
    ? HubTab.FLAGGED
    : raw === HubTab.TRANSFERRED
      ? HubTab.TRANSFERRED
      : raw === HubTab.TRANSFERRED_INTERNAL
        ? HubTab.TRANSFERRED_INTERNAL
        : raw === HubTab.RESOLVED
          ? HubTab.RESOLVED
          : raw === HubTab.ALL
            ? HubTab.ALL
            : undefined;
}
